import React from 'react';
import {useTranslation} from "../../contexts/TranslationContext";

const withTranslation = (Component) => {
  return (props) => {
    const translations = useTranslation();
    const t = (key) => translations[key] || key; // Simple translation function
    return <Component {...props} t={t} />;
  };
};

export default withTranslation;
